
import { RouteObject } from "react-router-dom";
import { lazy } from "react";
import ProtectedRoute from "../components/ProtectedRoute";

const LandingPage = lazy(() => import("../pages/landing/page"));
const Login = lazy(() => import("../pages/login/page"));
const Onboarding = lazy(() => import("../pages/onboarding/page"));
const Dashboard = lazy(() => import("../pages/dashboard/page"));
const Transactions = lazy(() => import("../pages/transactions/page"));
const Budget = lazy(() => import("../pages/budget/page"));
const Goals = lazy(() => import("../pages/goals/page"));
const Debts = lazy(() => import("../pages/debts/page"));
const Profile = lazy(() => import("../pages/profile/page"));
const Pricing = lazy(() => import("../pages/pricing/page"));
const Subscription = lazy(() => import("../pages/subscription/page"));
const Booking = lazy(() => import("../pages/booking/page"));
const Assistant = lazy(() => import("../pages/assistant/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/onboarding",
    element: (
      <ProtectedRoute>
        <Onboarding />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/transactions",
    element: (
      <ProtectedRoute>
        <Transactions />
      </ProtectedRoute>
    ),
  },
  {
    path: "/budget",
    element: (
      <ProtectedRoute>
        <Budget />
      </ProtectedRoute>
    ),
  },
  {
    path: "/goals",
    element: (
      <ProtectedRoute>
        <Goals />
      </ProtectedRoute>
    ),
  },
  {
    path: "/debts",
    element: (
      <ProtectedRoute>
        <Debts />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/subscription",
    element: (
      <ProtectedRoute>
        <Subscription />
      </ProtectedRoute>
    ),
  },
  {
    path: "/booking",
    element: (
      <ProtectedRoute>
        <Booking />
      </ProtectedRoute>
    ),
  },
  {
    path: "/assistant",
    element: (
      <ProtectedRoute>
        <Assistant />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
